import { DefaultEmailStyles } from '@wix/shoutout-email-model-v3';
import { elementMutatorFactory } from './element-mutator';
var colorMutatorFactory = function (defaults) {
    return elementMutatorFactory(function ($el) {
        $el.css('color', $el.css('color') || defaults.color);
    });
};
var textDecorationMutatorFactory = function (defaults) {
    return elementMutatorFactory(function ($el) {
        $el.css('text-decoration', $el.css('text-decoration') || defaults.textDecoration);
    });
};
export var linkStyleInjectorFactory = function () {
    var defaults = DefaultEmailStyles.a;
    return {
        elements: ['a'],
        mutators: [
            colorMutatorFactory(defaults),
            textDecorationMutatorFactory(defaults),
        ],
    };
};
//# sourceMappingURL=inject-missing-link-style.js.map